module.exports = __webpack_public_path__ + "static/media/NICE_Step2a_Image2i.77605cf8.jpg";